<template>
  <div class="template-create__wrapper">
    <div class="template-create-bottom">
      <div class="form-wrapper">
        <VForm :fields="fields" :name="name" hideSubmit> </VForm>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

// components
import VForm from "@/components/VForm";
import VRadioSelect from "@/components/VRadioSelect";

import { required, maxLength } from "@/utils/validations";
import withForm from "@/mixins/withForm";

import postcardIcon from "@/assets/images/postcard-icon.svg";
import pdfIcon from "@/assets/images/pdf-icon.svg";
import htmlIcon from "@/assets/images/html-icon.svg";

export default Vue.component("TemplatesCreateForm", {
  props: {
    templateType: VueTypes.oneOf(["postcard", "letter"]).def("postcard")
  },

  mixins: [withForm],

  components: {
    VForm,
    VRadioSelect
  },

  data() {
    return {
      name: "createTemplate",
      currentOption: null
    };
  },

  computed: {
    _isPostcard() {
      return this.templateType === "postcard";
    },

    _options() {
      if (this._isPostcard) {
        return [
          {
            key: "postcard-4x6",
            value: "postcard-4x6",
            header: "Postcard",
            text: "4x6 First Class",
            iconSrc: postcardIcon
          },
          {
            key: "postcard-6x9",
            value: "postcard-6x9",
            header: "Postcard",
            text: "6x9 First Class",
            iconSrc: postcardIcon
          },
          {
            key: "postcard-6x11",
            value: "postcard-6x11",
            header: "Postcard",
            text: "6x11 First Class",
            iconSrc: postcardIcon
          }
        ];
      }

      return [
        {
          key: "pdf",
          value: "pdf",
          title: "PDF",
          iconSrc: pdfIcon
        },
        {
          key: "html",
          value: "html",
          title: "HTML",
          iconSrc: htmlIcon
        }
      ];
    },

    fields() {
      return [
        {
          label: "Template Name",
          name: "name",
          classType: "primary",
          placeholder: "Enter name",
          validate: [required, maxLength(255)],
          isRequired: true
        }
      ];
    }
  },

  methods: {
    onSelect(selected) {
      this.currentOption = selected;
      this.$emit("templatetype", selected);
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "template-create";

hr {
  margin-block-start: 1em;
}

.#{$ns}__wrapper {
  color: $primary-text-color;
}

.#{$ns}-bottom {
  margin-top: 30px;
}

.#{$ns}__heading {
  text-align: left;
  font-size: 22px;
  line-height: 1.2;
  margin-bottom: 30px;
}

.#{$ns}__select {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/ .templates-modal .v-select__current-value {
  height: 66px;
  box-shadow: 2px 2px 25px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 13px 15px;
}
</style>
